import { createPostApi } from "@api/util/createPostApi";

import type { IApiResponse } from "@api";

import type { IPathBaseParam } from "./path";
import type { ISetCurrentUserPasswordDto } from "./types";

const postApis = createPostApi<
  IApiResponse<unknown>,
  IPathBaseParam,
  ISetCurrentUserPasswordDto
>("users.me.setPassword");

export const setPassword = {
  ...postApis,
};
